import {addLocaleData, IntlProvider} from 'react-intl';

import {getTranslationsData} from './translation';
import loadIntl from '../../common/load-intl';

const initialState = window.__INITIAL_STATE__;

loadIntl(global);

// eslint-disable-next-line import/no-dynamic-require
const data = require(`react-intl/locale-data/${initialState.xl.localization.lang}`);
addLocaleData(data);

const {intl} = new IntlProvider(
  {
    locale: initialState.xl.localization.lang,
    messages: getTranslationsData(initialState.xl.localization.translation)
  },
  {}
).getChildContext();

export const countryKeys = Object.keys(intl.messages).filter(key =>
  key.includes('form.select.country-name.')
);

export const getCountryNames = codes =>
  codes.map(key => intl.messages[`form.select.country-name.${key}`]);

export const countryMapping = countryKeys.reduce(
  (acc, item) => ({
    ...acc,
    [intl.messages[item]]: item.slice(-2),
    [item.slice(-2)]: intl.messages[item]
  }),
  {}
);



// WEBPACK FOOTER //
// ./utils/country-mapping.js